import { ToolMode } from '../mode';
import { ArrowTool } from './arrow';
import { EllipseTool } from './ellipse';
import { EraserTool } from './eraser';
import { LineTool } from './line';
import { RectangleTool } from './rectangle';
import { TextboxTool } from './textbox';
import { DrawingTool as InternalDrawingTool } from './tool';

const penTool = new InternalDrawingTool(ToolMode.FREEDRAW);
export const DrawingTool = Object.freeze({
    PEN: penTool,
    SELECT: new InternalDrawingTool(ToolMode.SELECT),
    RECTANGLE: new RectangleTool(),
    ELLIPSE: new EllipseTool(),
    LINE: new LineTool(),
    TEXTBOX: new TextboxTool(),
    ARROW: new ArrowTool(),
    ERASER: new EraserTool(),
    NONE: new InternalDrawingTool(ToolMode.DISABLED),
    DEFAULT: penTool,
    [Symbol.hasInstance](v: unknown): boolean {
        return v instanceof InternalDrawingTool;
    },
});

export type DrawingTool = InternalDrawingTool;
